import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, NgZone } from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NotificationService } from 'src/app/features/notifications/notification.service';
import { Address } from 'src/app/shared/model/address';
import { RoomParticipant } from 'src/app/shared/model/messages/message-room-participant';
import { Register } from 'src/app/shared/model/register';
import { UpdateUser } from 'src/app/shared/model/update-user';
import { User } from 'src/app/shared/model/user';
import { ApiService } from 'src/app/shared/service/http.service';
import { environment } from 'src/environments/environment';
//import { BaseURL } from 'src/environments/environment.development';
// new for error

import { Animal } from '../../shared/model/animal';
import { UserActions } from '../../state/user.actions';
import { timeout } from "rxjs/operators";
import { FriendsDto } from 'src/app/shared/model/friendsDto';
import { UserSummaryDto } from 'src/app/shared/model/UserSummaryDto';
@Injectable({
  providedIn: "root",
})
export class UserService {
  api = inject(ApiService);
  store = inject(Store);
  http = inject(HttpClient);
  private notificationService = inject(NotificationService);
  private ngZone = inject(NgZone);

  private userRoutes = environment.api.user;
   // new for about text error PET-824 /private userBasePath = `${BaseURL}/User`;
  private trainingCache = new Map<number, any>();

  // Lives in this singleton (not a component) so it survives components being
  // destroyed/recreated (e.g. switching tabs), instead of losing live updates on remount.
  private friendsSource = new BehaviorSubject<User[]>([]);
  public friendsLive$ = this.friendsSource.asObservable();
  private friendsLiveUserId?: number;
  private friendsLiveListenersRegistered = false;

  ensureFriendsLiveUpdates(userId: number): void {
    this.friendsLiveUserId = userId;
    this.getFriends(userId).subscribe(friends => this.friendsSource.next(friends));

    if (this.friendsLiveListenersRegistered) return;
    this.friendsLiveListenersRegistered = true;

    ['FriendRequestAccepted', 'FriendDeleted', 'FriendListUpdated', 'UpdateFriendList'].forEach(event =>
      this.notificationService.on(event, (payload: any) => {
        // TEMPORARY DEBUG LOG — remove once SignalR reliability issue is diagnosed
        console.log(`[FriendsDebug] ${event} fired`, payload);
        if (!this.friendsLiveUserId) return;
        this.getFriends(this.friendsLiveUserId).subscribe(friends => {
          this.ngZone.run(() => {
            this.friendsSource.next(friends);
            // TEMPORARY DEBUG LOG — remove once SignalR reliability issue is diagnosed
            console.log(`[FriendsDebug] ${event} friendsSource.next called (in zone)`, friends);
          });
        });
      })
    );
  }

  get currentUser$(): Observable<User | null> {
    return this.store.select((state) => state.user.currentUser);
  }

  getInfo(id?: number): Observable<User> {
    return this.api.Get(
      this.userRoutes.getUser,
      id ? { params: { id } } : undefined,
    );
  }

  getLoginUser(id?: number): Observable<UserSummaryDto> {
    return this.api.Get(
      this.userRoutes.getLoginUser,
      id ? { params: { id } } : undefined,
    );
  }

  getFriends(id?: number): Observable<User[]> {
    return this.api.Get<User[]>(this.userRoutes.friends, {
      params: { id },
    });
  }

  getUserFriends(id?: number): Observable<FriendsDto[]> {
    return this.api.Get<FriendsDto[]>(this.userRoutes.userFriends, {
      params: { id },
    });
  }

  getAllUsers(): Observable<RoomParticipant[]> {
    return this.api.Get<RoomParticipant[]>(this.userRoutes.getAllUsers, {});
  }

  getAnimals(ownerId?: number) {
    return this.api.Get<Animal[]>(
      this.userRoutes.animals,
      ownerId ? { params: { ownerId } } : undefined,
    );
  }

  getUserAnimals(ownerId?: number) {
    return this.api.Get<Animal[]>(
      this.userRoutes.userAnimals,
      ownerId ? { params: { ownerId } } : undefined,
    );
  }

  // updateCustomerProfile(updateUser: UpdateUser): Observable<User> {
  //   return this.api.Post<User>(this.userRoutes.update, updateUser).pipe(
  //     tap((res) => {
  //       if (res) {
  //         this.store.dispatch(UserActions.setUser({ newUser: res }));
  //       }
  //     }),
  //   );
  // }
  updateCustomerProfile(updateUser: UpdateUser): Observable<User> {
    return this.api.Post<User>(this.userRoutes.update, updateUser);
  }

  getUserData(socialSecurityNr: string): Observable<User> {
    return this.api.Get<User>(this.userRoutes.getData, {
      params: { socialSecurityNr },
    });
  }
  getLocationByZipCode(zipCode: string): Observable<any> {
    return this.http
      .get(
        `https://nominatim.openstreetmap.org/search?postalcode=${zipCode}&country=SE&format=json&limit=1`,
        { headers: { "Accept-Language": "sv" } },
      )
      .pipe(timeout(5000));
  }

  public addUser(registerData: Register): Observable<Register> {
    return this.api.Post<Register>(this.userRoutes.register, registerData);
  }

  updateAddress(userId: number, address: Address): Observable<Address> {
    console.debug("Updating adress:", address);
    return this.api.Put<Address>(
      `${environment.api.basePath}/User/${userId}/address`,
      address,
    );
  }

  getAddress(userId: number): Observable<Address> {
    return this.api.Get<Address>(
      `${environment.api.basePath}/User/${userId}/address`,
    );
  }

  deleteUser() {
    return this.api.Delete<void>(this.userRoutes.delete);
  }

  // ABOUT

  getAboutText(userId: number): Observable<string> {
    return this.http.get(`${environment.api.basePath}/User/${userId}/about`, {
      responseType: "text" as const,
    });
  }

  getPostCount(userId: number): Observable<number> {
    return this.http.get<number>(
      `${environment.api.basePath}/User/${userId}/post-count`,
    );
  }
  /*   / new for about text error PET-824

   updateAbout(
     userId: number,
     aboutText: string,
   ): Observable<{ aboutText: string }> {
     return this.api.Put<{ aboutText: string }>(
       `${this.userBasePath}/${userId}/about`,
       {
         aboutText,
       },
     );
   }*/
  updateAbout(
    userId: number,
    aboutText: string,
  ): Observable<{ aboutText: string }> {
    return this.api.Put<{ aboutText: string }>(
      `${environment.api.basePath}/User/${userId}/about`,
      {
        aboutText,
      },
    );
  }
  deleteProfilePicture(): Observable<User> {
    return this.api
      .Delete<User>(`${environment.baseUrl}/User/ProfilePicture`)
      .pipe(
        tap((res) => {
          if (res) {
            this.store.dispatch(UserActions.setUser({ newUser: res }));
          }
        }),
      );
  }
  changePassword(payload: {
    currentPassword: string;
    newPassword: string;
  }): Observable<void> {
    return this.api.Post<void>(
      `${environment.api.basePath}/Auth/ChangePassword`,
      payload,
    );
  }
  requestEmailChange(newEmail: string): Observable<void> {
    return this.api.Post<void>(
      `${environment.api.basePath}/Auth/RequestEmailChange`,
      { newEmail },
    );
  }

  confirmEmailChange(token: string, email: string): Observable<void> {
    return this.api.Get(
      `${environment.api.basePath}/Auth/ConfirmEmailChange?token=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}`,
    );
  }

  //TRAINING METHODS

  createTraining(trainingData: unknown): Observable<unknown> {
    return this.api.Post<unknown>(
      `${environment.api.basePath}/Training`,
      trainingData
    );
  }

  getTrainingById(sessionId: number): Observable<any> {
    if (this.trainingCache.has(sessionId)) {
      return of(this.trainingCache.get(sessionId));
    }

    return this.api.Get<any>(
      `${environment.api.basePath}/Training/${sessionId}`
    ).pipe(
      tap(training => this.trainingCache.set(sessionId, training))
    );
  }




  addExerciseToTraining(sessionId: number, exerciseData: unknown): Observable<unknown> {
    return this.api.Post<unknown>(
      `${environment.api.basePath}/Training/${sessionId}/exercises`,
      exerciseData
    );
  }
  joinTrainingSession(sessionId: number, animalId: number): Observable<unknown> {
    return this.api.Post<unknown>(
      `${environment.api.basePath}/Training/${sessionId}/join?animalId=${animalId}`,
      {}
    );
  }


  confirmEmail(token: string, email: string): Observable<void> {
    return this.api.Get(
      `${environment.api.basePath}/Auth/ConfirmEmail?token=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}`,
    );
  }
}